import {useState, useEffect, useRef, useCallback} from "react";
import {useParams} from "react-router-dom";
import React from "react";
import {getAllShifts, getShiftReport, getDeliveryGuysByShift, apiFetchDeliveryGuyLocation} from "../service/api/orders";
import { AlertCircle, TrendingUp,  ChevronRight, Phone,
    IndianRupee, Bike, Mail, Calendar, RefreshCw,
    MapPin, User, Banknote, Bell  } from "lucide-react";
import L from "leaflet";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";





delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    iconUrl:       "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    shadowUrl:     "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});


const makeIcon = (heading, color = "#6366f1") => {
    const deg = isNaN(Number(heading)) ? 0 : Number(heading);
    const uid = Math.random().toString(36).slice(2, 6);
    // Pin never rotates — only the emoji inside spins by heading.
    return L.divIcon({
        html: `
        <div style="width:42px;height:52px;">
            <svg viewBox="0 0 42 52" width="42" height="52" xmlns="http://www.w3.org/2000/svg">
                <filter id="rs-${uid}">
                    <feDropShadow dx="0" dy="3" stdDeviation="3" flood-color="${color}" flood-opacity="0.35"/>
                    <feDropShadow dx="0" dy="1" stdDeviation="1" flood-opacity="0.15"/>
                </filter>
                <path d="M21 2C12.16 2 5 9.16 5 18c0 11.5 16 31 16 31S37 29.5 37 18C37 9.16 29.84 2 21 2z"
                    fill="${color}" filter="url(#rs-${uid})"/>
                <circle cx="21" cy="17" r="11" fill="white" opacity="0.92"/>
                <circle cx="21" cy="17" r="11" fill="none" stroke="${color}" stroke-width="1.2" opacity="0.3"/>
                <!-- foreignObject fixed to pin; emoji rotates inside it by heading -->
                <foreignObject x="7" y="5" width="28" height="26">
                    <div xmlns="http://www.w3.org/1999/xhtml"
                        style="width:28px;height:26px;display:flex;align-items:center;justify-content:center;font-size:14px;line-height:1;user-select:none;transform:rotate(${deg}deg);transform-origin:center;">
                        🛵
                    </div>
                </foreignObject>
            </svg>
        </div>`,
        className: "",
        iconSize:    [42, 52],
        iconAnchor:  [21, 50],
        popupAnchor: [0, -54],
    });
};

// Icons
const Icon = {
    Login:     () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/></svg>,
    Logout:    () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
    Zap:       () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>,
    Moon:      () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>,
    Mail:      () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>,
    Check:     () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>,
    Bar:       () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
    Clock:     () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
    ChevDown:  () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"/></svg>,
    ChevRight: () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>,
    Search:    () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
    Spin:      () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ animation: "spin 1s linear infinite" }}><line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"/><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"/><line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"/><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"/></svg>,
    Riders:    () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
    Menu:      () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>,
    Empty:     () => <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
};

// ─── Design tokens ────────────────────────────────────────────────────────────
const T = {
    bg:      "#f4f5f7",
    white:   "#ffffff",
    border:  "#e2e4e9",
    text:    "#1a1d23",
    muted:   "#8b91a1",
    subtle:  "#f8f9fb",
    blue:    "#2563eb",
    blueB:   "#dbeafe",
    green:   "#15803d",
    greenB:  "#dcfce7",
    red:     "#dc2626",
    redB:    "#fee2e2",
    amber:   "#b45309",
    amberB:  "#fef3c7",
    purple:  "#7c3aed",
    purpleB: "#ede9fe",
    sideW:   260,
};

// ─── Helpers ──────────────────────────────────────────────────────────────────
const fmtSec = (s) => {
    if (!s || s === 0) return "—";

    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;

    if (h > 0 && m > 0 && sec > 0) return `${h}h ${m}m ${sec}s`;
    if (h > 0 && m > 0) return `${h}h ${m}m`;
    if (h > 0 && sec > 0) return `${h}h ${sec}s`;
    if (m > 0 && sec > 0) return `${m}m ${sec}s`;
    if (h > 0) return `${h}h`;
    if (m > 0) return `${m}m`;
    return `${sec}s`;
};

const fmt12         = (t) => { if (!t) return ""; const [h, m] = t.split(":").map(Number); return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${h >= 12 ? "PM" : "AM"}`; };
const toDisplayDate = (iso) => new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short" });
const toDayName     = (iso) => new Date(iso).toLocaleDateString("en-IN", { weekday: "short" });
const toApiDate     = (ymd) => { const [y, mo, d] = ymd.split("-"); return `${d}-${mo}-${y}`; };
const getIstDate = () => {
    const nowUtc = new Date();
    return new Date(nowUtc.getTime() + 5.5 * 60 * 60 * 1000);
};

const todayStr = () => getIstDate().toISOString().slice(0, 10);
const sevenAgo = () => {
    const d = getIstDate();
    d.setUTCDate(d.getUTCDate() - 6);
    return d.toISOString().slice(0, 10);
};

const initials      = (name = "") => name.trim().split(/\s+/).map(w => w[0]).slice(0, 2).join("").toUpperCase();
const avatarBg      = (name = "") => { const p = ["#2563eb","#7c3aed","#15803d","#b45309","#dc2626","#0891b2","#c026d3","#0d9488"]; return p[(name.charCodeAt(0) || 0) % p.length]; };

// ─── Shift period calculator ──────────────────────────────────────────────────
const DAY_MAP = { Sunday: 0, Monday: 1, Tuesday: 2, Wednesday: 3, Thursday: 4, Friday: 5, Saturday: 6 };

function getShiftPeriod(shift) {
    if (!shift?.from_day || !shift?.to_day) {
        return { from: sevenAgo(), to: todayStr() };
    }

    const fromDow = DAY_MAP[shift.from_day];
    const toDow   = DAY_MAP[shift.to_day];

    const nowUtc = new Date();
    const istOffset = 5.5 * 60 * 60 * 1000;
    const nowIst = new Date(nowUtc.getTime() + istOffset);

    const todayDow = nowIst.getUTCDay();

    const daysBack = (todayDow - fromDow + 7) % 7;
    const fromDate = new Date(nowIst);
    fromDate.setUTCDate(nowIst.getUTCDate() - daysBack);

    let daysAhead = (toDow - fromDow + 7) % 7;
    if (daysAhead === 0) daysAhead = 7;
    const toDate = new Date(fromDate);
    toDate.setUTCDate(fromDate.getUTCDate() + daysAhead);

    const fmt = (d) => d.toISOString().slice(0, 10);

    return {
        from: fmt(fromDate),
        to:   fmt(toDate),
    };
}

// ─── Tiny components ──────────────────────────────────────────────────────────
function Pill({ color, children }) {
    const map = { green:[T.green,T.greenB], red:[T.red,T.redB], amber:[T.amber,T.amberB], blue:[T.blue,T.blueB], purple:[T.purple,T.purpleB] };
    const [fg, bg] = map[color] ?? map.blue;
    return <span style={{ background: bg, color: fg, border: `1px solid ${fg}33`, borderRadius: 5, padding: "2px 8px", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap" }}>{children}</span>;
}

function Avatar({ name = "", size = 32 }) {
    return <div style={{ width: size, height: size, borderRadius: "50%", background: avatarBg(name), color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: Math.round(size * 0.33), fontWeight: 800, flexShrink: 0, letterSpacing: "-0.01em", userSelect: "none" }}>{initials(name)}</div>;
}

// ─── [NEW] Animated online dot ────────────────────────────────────────────────
function OnlineDot({ size = 8 }) {
    return (
        <div style={{ position: "relative", width: size, height: size, flexShrink: 0 }}>
            <div style={{ position: "absolute", inset: -(size * 0.5), borderRadius: "50%", background: T.green, opacity: 0.25, animation: "onlinePulse 1.8s ease-in-out infinite" }} />
            <div style={{ width: size, height: size, borderRadius: "50%", background: T.green, position: "relative", zIndex: 1 }} />
        </div>
    );
}

function StatCard({ label, value, sub, color = "blue", icon: IC }) {
    const fg = { green:T.green, red:T.red, amber:T.amber, blue:T.blue, purple:T.purple }[color];
    const bg = { green:T.greenB, red:T.redB, amber:T.amberB, blue:T.blueB, purple:T.purpleB }[color];
    return (
        <div style={{ background: T.white, border: `1px solid ${T.border}`, borderRadius: 10, padding: "15px 14px", display: "flex", alignItems: "center", gap: 10, flex: "1 1 150px", minWidth: 140 }}>
            <div style={{ width: 32, height: 32, borderRadius: 8, background: bg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, color: fg }}>{IC && <IC />}</div>
            <div>
                <div style={{ fontSize: 10, color: T.muted, fontWeight: 700, letterSpacing: "0.05em", textTransform: "uppercase" }}>{label}</div>
                <div style={{ fontSize: 18, fontWeight: 800, color: fg, lineHeight: 1.15 }}>{value}</div>
                {sub && <div style={{ fontSize: 10, color: T.muted, marginTop: 1 }}>{sub}</div>}
            </div>
        </div>
    );
}

function EmptyState({ icon, title, sub }) {
    return (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", minHeight: 300, padding: "40px 20px", textAlign: "center", color: T.muted }}>
            <div style={{ marginBottom: 16, opacity: 0.3 }}>{icon}</div>
            <div style={{ fontSize: 15, fontWeight: 700, color: T.text, marginBottom: 6 }}>{title}</div>
            <div style={{ fontSize: 13 }}>{sub}</div>
        </div>
    );
}

// ─── DayDetailModal ───────────────────────────────────────────────────────────
function DayDetailModal({ day, dayObj, shift, guyName, onClose, onOrderClick }) {
    const [tab, setTab] = useState(0);
    const [expandedOffers, setExpandedOffers] = useState(new Set());


    const toggleOffer = (orderId) => {
        setExpandedOffers(prev => {
            const next = new Set(prev);
            next.has(orderId) ? next.delete(orderId) : next.add(orderId);
            return next;
        });
    };

    useEffect(() => {
        const handler = (e) => { if (e.key === "Escape") onClose(); };
        document.addEventListener("keydown", handler);
        document.body.style.overflow = "hidden";
        return () => { document.removeEventListener("keydown", handler); document.body.style.overflow = ""; };
    }, [onClose]);

    if (!dayObj) return null;

    const events       = dayObj.events        ?? [];
    const orders       = dayObj.orders        ?? [];
    const actionOrders = dayObj.action_orders ?? [];
    const accepted = orders.filter(o => o.status === "accepted").length;
    const done     = orders.filter(o => o.status === "done").length;
    const rejected = orders.filter(o => o.status === "rejected").length;

    const evDay    = new Date(day).getDate();
    const monthStr = new Date(day).toLocaleDateString("en-IN", { month: "short" });
    const weekday  = new Date(day).toLocaleDateString("en-IN", { weekday: "long" });

    const earnings      = dayObj.earnings      ?? { commission: 0, tip: 0, surge: 0, total: 0, orders: [] };


    const TABS = [
        { label: "Timeline",      icon: <Icon.Clock />,            badge: events.length,        badgeColor: [T.blueB,   T.blue]   },
        { label: "Orders",        icon: <Icon.Mail />,             badge: orders.length,        badgeColor: [T.purpleB, T.purple] },
        { label: "Action Orders", icon: <AlertCircle size={13} />, badge: actionOrders.length,  badgeColor: [T.redB,    T.red]    },
        { label: "Earnings",      icon: <IndianRupee size={13} />, badge: earnings.orders.length, badgeColor: [T.greenB, T.green] },
    ];

    return (
        <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(15,20,30,.45)", zIndex: 900, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, backdropFilter: "blur(2px)" }}>
            <div onClick={e => e.stopPropagation()} style={{ background: T.white, borderRadius: 16, width: "100%", maxWidth: 780, marginTop: 56, height: "calc(100vh - 56px - 40px)", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 24px 60px rgba(0,0,0,.18)" }}>

                {/* Header */}
                <div style={{ flexShrink: 0, padding: "16px 20px 0", borderBottom: `1px solid ${T.border}`, background: T.white }}>
                    <div style={{ display: "flex", alignItems: "flex-start", gap: 12, marginBottom: 14 }}>
                        <div style={{ flex: 1 }}>
                            <div style={{ fontSize: 16, fontWeight: 800, color: T.text }}>{evDay} {monthStr} · {weekday}</div>
                            <div style={{ fontSize: 12, color: T.muted, marginTop: 3 }}>{guyName} · {shift?.shift_name} · {fmt12(shift?.start_time)} – {fmt12(shift?.end_time)}</div>
                        </div>
                        <button onClick={onClose} style={{ width: 30, height: 30, borderRadius: 8, border: `1px solid ${T.border}`, background: "none", cursor: "pointer", fontSize: 16, color: T.muted, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>✕</button>
                    </div>
                    <div style={{ display: "flex" }}>
                        {TABS.map((t, i) => {
                            const active = tab === i;
                            return (
                                <button key={i} onClick={() => setTab(i)} style={{ display: "flex", alignItems: "center", gap: 6, padding: "9px 16px", fontSize: 12, fontWeight: active ? 700 : 500, color: active ? T.blue : T.muted, background: "none", border: "none", borderBottom: active ? `2px solid ${T.blue}` : "2px solid transparent", marginBottom: -1, cursor: "pointer", transition: "color .15s, border-color .15s", whiteSpace: "nowrap" }}>
                                    <span style={{ display: "flex", color: active ? T.blue : T.muted }}>{t.icon}</span>
                                    {t.label}
                                    {t.badge > 0 && (
                                        <span style={{ background: active ? t.badgeColor[0] : T.subtle, color: active ? t.badgeColor[1] : T.muted, borderRadius: 10, padding: "1px 7px", fontSize: 10, fontWeight: 800, border: `1px solid ${active ? t.badgeColor[1] + "33" : T.border}` }}>{t.badge}</span>
                                    )}
                                </button>
                            );
                        })}
                    </div>
                </div>

                {/* Tab bodies */}
                <div style={{flex: 1, minHeight: 0, position: "relative"}}>

                    {/* TAB 0: Timeline */}
                    <div style={{
                        position: "absolute",
                        inset: 0,
                        overflowY: "auto",
                        display: tab === 0 ? "block" : "none"
                    }}>
                        {events.length === 0 ? (
                            <div style={{padding: "48px 20px", textAlign: "center", color: T.muted, fontSize: 13}}>No
                                login or logout events recorded for this day.</div>
                        ) : (
                            <div style={{padding: "14px 0"}}>
                                {events.map((ev, idx) => {
                                    const isLogin = ev.status === "ONLINE";
                                    const isLast = idx === events.length - 1;
                                    const nextStatus = !isLast ? events[idx + 1]?.status : null;
                                    const showGap = !isLogin && nextStatus === "ONLINE";
                                    return (
                                        <div key={idx}
                                             style={{display: "flex", alignItems: "flex-start", padding: "0 20px"}}>
                                            <div style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                width: 20,
                                                flexShrink: 0,
                                                marginTop: 14
                                            }}>
                                                <div style={{
                                                    width: 10,
                                                    height: 10,
                                                    borderRadius: "50%",
                                                    background: isLogin ? T.green : T.red,
                                                    border: `2px solid ${T.white}`,
                                                    boxShadow: `0 0 0 1.5px ${isLogin ? T.green : T.red}`
                                                }}/>
                                                {!isLast && <div style={{
                                                    width: 2,
                                                    flex: 1,
                                                    minHeight: 20,
                                                    margin: "2px 0",
                                                    background: `linear-gradient(${isLogin ? T.green : T.red}, ${T.border})`
                                                }}/>}
                                            </div>
                                            <div style={{
                                                flex: 1,
                                                padding: "10px 0 10px 14px",
                                                borderBottom: isLast ? "none" : `1px solid ${T.border}`
                                            }}>
                                                <div style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 8,
                                                    flexWrap: "wrap"
                                                }}>
                                                    <span style={{
                                                        fontSize: 10,
                                                        fontWeight: 800,
                                                        background: T.subtle,
                                                        border: `1px solid ${T.border}`,
                                                        borderRadius: 4,
                                                        padding: "1px 6px",
                                                        color: T.muted
                                                    }}>{evDay}</span>
                                                    <span style={{fontSize: 13, fontWeight: 800}}>{ev.created_at}</span>
                                                    <Pill
                                                        color={isLogin ? "green" : "red"}>{isLogin ? "↗ Login" : "↙ Logout"}</Pill>
                                                    {showGap && <span style={{
                                                        fontSize: 10,
                                                        color: T.red,
                                                        fontWeight: 700,
                                                        background: T.redB,
                                                        borderRadius: 4,
                                                        padding: "1px 6px"
                                                    }}>offline gap ↓</span>}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>

                    {/* TAB 1: Orders */}
                    <div style={{
                        position: "absolute",
                        inset: 0,
                        overflowY: "auto",
                        overflowX: "auto",
                        display: tab === 1 ? "flex" : "none",
                        flexDirection: "column"
                    }}>
                        <div style={{
                            flexShrink: 0,
                            display: "flex",
                            gap: 8,
                            padding: "12px 20px",
                            borderBottom: `1px solid ${T.border}`,
                            background: T.subtle,
                            flexWrap: "wrap"
                        }}>
                            {[
                                {label: "Offered", val: orders.length, bg: T.purpleB, fg: T.purple},
                                {label: "Accepted", val: accepted, bg: T.blueB, fg: T.blue},
                                {label: "Done", val: done, bg: T.greenB, fg: T.green},
                                {label: "Rejected", val: rejected, bg: T.redB, fg: T.red},
                            ].map(({label, val, bg, fg}) => (
                                <div key={label} style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 6,
                                    background: bg,
                                    borderRadius: 8,
                                    padding: "5px 11px",
                                    border: `1px solid ${fg}33`
                                }}>
                                    <span style={{fontSize: 15, fontWeight: 800, color: fg}}>{val}</span>
                                    <span
                                        style={{fontSize: 11, fontWeight: 600, color: fg, opacity: 0.75}}>{label}</span>
                                </div>
                            ))}
                        </div>
                        {orders.length === 0 ? (
                            <div style={{padding: "48px 20px", textAlign: "center", color: T.muted, fontSize: 13}}>No
                                orders were offered during this shift.</div>
                        ) : (
                            <div style={{flex: 1, minHeight: 0, overflowX: "auto"}}>
                                <table style={{width: "100%", borderCollapse: "collapse", minWidth: 520}}>
                                    <thead>
                                    <tr>{["", "#", "Order ID", "Offered At", "Responded At", "Status"].map(h => (
                                        <th key={h} style={{
                                            padding: "9px 14px",
                                            fontSize: 10,
                                            fontWeight: 700,
                                            textTransform: "uppercase",
                                            letterSpacing: "0.05em",
                                            color: T.muted,
                                            textAlign: "left",
                                            whiteSpace: "nowrap",
                                            position: "sticky",
                                            top: 0,
                                            background: T.subtle,
                                            borderBottom: `1px solid ${T.border}`,
                                            zIndex: 1
                                        }}>{h}</th>
                                    ))}</tr>
                                    </thead>
                                    <tbody>
                                    {orders.map((o, idx) => {
                                        const statusMap = {
                                            accepted: {color: "blue", label: "✓ Accepted"},
                                            done: {color: "green", label: "✓ Done"},
                                            rejected: {color: "red", label: "✗ Rejected"},
                                        };
                                        const s = statusMap[o.status] ?? {color: "amber", label: o.status};
                                        const hasOverlap = o.overlapping_orders?.length > 0;
                                        const isExpanded = expandedOffers.has(o.order_id);

                                        return (
                                            <React.Fragment key={idx}>
                                                <tr
                                                    style={{background: isExpanded ? T.blueB : undefined}}
                                                    onMouseEnter={e => {
                                                        if (!isExpanded) e.currentTarget.style.background = T.subtle;
                                                    }}
                                                    onMouseLeave={e => {
                                                        if (!isExpanded) e.currentTarget.style.background = "";
                                                    }}
                                                >
                                                    {/* expand toggle cell */}
                                                    <td style={{
                                                        padding: "10px 6px 10px 10px",
                                                        borderTop: `1px solid ${T.border}`,
                                                        width: 24
                                                    }}>
                                                        {hasOverlap && (
                                                            <button
                                                                onClick={() => toggleOffer(o.order_id)}
                                                                style={{
                                                                    background: "none",
                                                                    border: "none",
                                                                    cursor: "pointer",
                                                                    padding: "0 2px",
                                                                    color: T.muted,
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    transform: isExpanded ? "rotate(90deg)" : "rotate(0deg)",
                                                                    transition: "transform .15s",
                                                                }}
                                                            >
                                                                <ChevronRight size={16}/>
                                                            </button>
                                                        )}
                                                    </td>
                                                    <td style={{
                                                        padding: "10px 14px",
                                                        fontSize: 12,
                                                        color: T.muted,
                                                        borderTop: `1px solid ${T.border}`
                                                    }}>{idx + 1}</td>
                                                    <td style={{
                                                        padding: "10px 14px",
                                                        borderTop: `1px solid ${T.border}`
                                                    }}>
                                                        <a
                                                            href={`/order/${o.unique_order_id}`}
                                                            target="_blank" rel="noopener noreferrer"
                                                            onClick={e => {
                                                                e.preventDefault();
                                                                onOrderClick(o.unique_order_id);
                                                            }}
                                                            style={{
                                                                display: "inline-flex",
                                                                alignItems: "center",
                                                                gap: 5,
                                                                fontSize: 12,
                                                                fontWeight: 700,
                                                                color: T.blue,
                                                                textDecoration: "none",
                                                                border: `1px solid ${T.blue}33`,
                                                                borderRadius: 6,
                                                                padding: "3px 9px",
                                                                cursor: "pointer"
                                                            }}
                                                        >
                                                            {/* open icon */}
                                                            <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
                                                                 stroke="currentColor" strokeWidth="2.5"
                                                                 strokeLinecap="round" strokeLinejoin="round">
                                                                <path
                                                                    d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                                                                <polyline points="15 3 21 3 21 9"/>
                                                                <line x1="10" y1="14" x2="21" y2="3"/>
                                                            </svg>
                                                            {o.unique_order_id}
                                                            {/* red dot if overlaps exist */}
                                                            {hasOverlap && (
                                                                <span style={{
                                                                    width: 6,
                                                                    height: 6,
                                                                    borderRadius: "50%",
                                                                    background: T.red,
                                                                    display: "inline-block",
                                                                    flexShrink: 0
                                                                }}
                                                                      title={`${o.overlapping_orders.length} in-hand overlap`}/>
                                                            )}
                                                        </a>
                                                    </td>
                                                    <td style={{
                                                        padding: "10px 14px",
                                                        borderTop: `1px solid ${T.border}`
                                                    }}>
                                                        <span style={{
                                                            fontSize: 10,
                                                            fontWeight: 800,
                                                            background: T.subtle,
                                                            border: `1px solid ${T.border}`,
                                                            borderRadius: 4,
                                                            padding: "1px 5px",
                                                            color: T.muted,
                                                            marginRight: 5
                                                        }}>{evDay}</span>
                                                        <span style={{
                                                            fontSize: 13,
                                                            fontWeight: 700
                                                        }}>{o.offered_at || "—"}</span>
                                                    </td>
                                                    <td style={{
                                                        padding: "10px 14px",
                                                        borderTop: `1px solid ${T.border}`
                                                    }}>
                                                        <span style={{
                                                            fontSize: 10,
                                                            fontWeight: 800,
                                                            background: T.subtle,
                                                            border: `1px solid ${T.border}`,
                                                            borderRadius: 4,
                                                            padding: "1px 5px",
                                                            color: T.muted,
                                                            marginRight: 5
                                                        }}>{evDay}</span>
                                                        <span style={{
                                                            fontSize: 13,
                                                            color: T.muted
                                                        }}>{o.responded_at || "—"}</span>
                                                    </td>
                                                    <td style={{
                                                        padding: "10px 14px",
                                                        borderTop: `1px solid ${T.border}`
                                                    }}><Pill color={s.color}>{s.label}</Pill></td>
                                                </tr>

                                                {/* ── Overlap sub-row ── */}
                                                {hasOverlap && isExpanded && (
                                                    <tr>
                                                        <td colSpan={6} style={{padding: 0, borderTop: "none"}}>
                                                            <div style={{padding: "8px 14px 10px 36px"}}>
                                                                <div style={{
                                                                    fontSize: 10,
                                                                    fontWeight: 700,
                                                                    textTransform: "uppercase",
                                                                    letterSpacing: "0.05em",
                                                                    color: T.red,
                                                                    marginBottom: 6,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: 6
                                                                }}>
                                                                    <span style={{
                                                                        width: 6,
                                                                        height: 6,
                                                                        borderRadius: "50%",
                                                                        background: T.red,
                                                                        display: "inline-block"
                                                                    }}/>
                                                                    Skipped — rider was
                                                                    carrying {o.overlapping_orders.length} order{o.overlapping_orders.length > 1 ? "s" : ""}
                                                                </div>
                                                                <div
                                                                    style={{display: "flex", flexWrap: "wrap", gap: 6}}>
                                                                    {o.overlapping_orders.map((ov, oi) => (
                                                                        <div key={oi} style={{
                                                                            background: T.white,
                                                                            border: `1px solid ${T.border}`,
                                                                            borderLeft: `3px solid ${T.blue}`,
                                                                            borderRadius: 8,
                                                                            padding: "6px 10px",
                                                                            fontSize: 12,
                                                                            minWidth: 190
                                                                        }}>
                                                                            <a
                                                                                href={`/order/${ov?.unique_order_id}`}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                onClick={e => {
                                                                                    e.preventDefault();
                                                                                    onOrderClick(ov?.unique_order_id);
                                                                                }}
                                                                                style={{
                                                                                    display: "inline-flex",
                                                                                    alignItems: "center",
                                                                                    gap: 5,
                                                                                    fontWeight: 700,
                                                                                    color: T.blue,
                                                                                    textDecoration: "none",
                                                                                    paddingTop: 5,
                                                                                    cursor: "pointer"
                                                                                }}
                                                                            >{ov.unique_order_id}</a>

                                                                            <div style={{
                                                                                color: T.muted,
                                                                                fontSize: 11,
                                                                                paddingBottom: 5,
                                                                                display: "flex",
                                                                                flexDirection: "column",
                                                                                gap: 2
                                                                            }}>
                                                                                <span
                                                                                    style={{marginTop: 3}}>Picked up &nbsp; {ov.picked_up_at}</span>
                                                                                <span
                                                                                    style={{marginTop: 3}}>Delivered &nbsp; {ov.delivered_at ?? "—"}</span>
                                                                            </div>
                                                                            {/*<span style={{ display: "inline-block", marginTop: 4, background: T.redB, color: T.red, border: `1px solid ${T.red}33`, borderRadius: 4, padding: "1px 7px", fontSize: 10, fontWeight: 700 }}>*/}
                                                                            {/*    overlapped {Math.round(ov.overlap_seconds / 60)} min*/}
                                                                            {/*</span>*/}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </React.Fragment>
                                        );
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>

                    {/* TAB 2: Action Orders */}
                    <div style={{
                        position: "absolute",
                        inset: 0,
                        overflowY: "auto",
                        overflowX: "auto",
                        display: tab === 2 ? "flex" : "none",
                        flexDirection: "column"
                    }}>
                        {actionOrders.length > 0 && (
                            <div style={{
                                flexShrink: 0,
                                display: "flex",
                                alignItems: "center",
                                gap: 8,
                                padding: "10px 20px",
                                background: T.redB,
                                borderBottom: `1px solid ${T.red}33`,
                                fontSize: 12,
                                color: T.red,
                                fontWeight: 600
                            }}>
                                🚨 {actionOrders.length} order{actionOrders.length !== 1 ? "s" : ""} delivered outside
                                the assigned shift window
                            </div>
                        )}
                        {actionOrders.length === 0 ? (
                            <div style={{padding: "48px 20px", textAlign: "center", color: T.muted, fontSize: 13}}>✅ No
                                action orders outside shift — all clear.</div>
                        ) : (
                            <div style={{flex: 1, minHeight: 0, overflowX: "auto"}}>
                                <table style={{width: "100%", borderCollapse: "collapse", minWidth: 400}}>
                                    <thead>
                                    <tr>{["#", "Order ID", "Accepted At", "Status"].map(h => (
                                        <th key={h} style={{
                                            padding: "9px 14px",
                                            fontSize: 10,
                                            fontWeight: 700,
                                            textTransform: "uppercase",
                                            letterSpacing: "0.05em",
                                            color: T.muted,
                                            textAlign: "left",
                                            position: "sticky",
                                            top: 0,
                                            background: T.subtle,
                                            borderBottom: `1px solid ${T.border}`,
                                            zIndex: 1
                                        }}>{h}</th>
                                    ))}</tr>
                                    </thead>
                                    <tbody>
                                    {actionOrders.map((o, idx) => (
                                        <tr key={idx} onMouseEnter={e => e.currentTarget.style.background = T.subtle}
                                            onMouseLeave={e => e.currentTarget.style.background = ""}>
                                            <td style={{
                                                padding: "10px 14px",
                                                fontSize: 12,
                                                color: T.muted,
                                                borderTop: `1px solid ${T.border}`
                                            }}>{idx + 1}</td>
                                            <td style={{padding: "10px 14px", borderTop: `1px solid ${T.border}`}}>
                                                <a href={`/order/${o.unique_order_id}`} target="_blank"
                                                   rel="noopener noreferrer" onClick={e => {
                                                    e.preventDefault();
                                                    onOrderClick(o.unique_order_id);
                                                }} style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: 5,
                                                    fontSize: 12,
                                                    fontWeight: 700,
                                                    color: T.red,
                                                    textDecoration: "none",
                                                    background: T.redB,
                                                    border: `1px solid ${T.red}33`,
                                                    borderRadius: 6,
                                                    padding: "3px 9px",
                                                    cursor: "pointer"
                                                }}>
                                                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none"
                                                         stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"
                                                         strokeLinejoin="round">
                                                        <path
                                                            d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                                                        <polyline points="15 3 21 3 21 9"/>
                                                        <line x1="10" y1="14" x2="21" y2="3"/>
                                                    </svg>
                                                    {o.unique_order_id}
                                                </a>
                                            </td>
                                            <td style={{padding: "10px 14px", borderTop: `1px solid ${T.border}`}}>
                                                <span style={{
                                                    fontSize: 10,
                                                    fontWeight: 800,
                                                    background: T.subtle,
                                                    border: `1px solid ${T.border}`,
                                                    borderRadius: 4,
                                                    padding: "1px 5px",
                                                    color: T.muted,
                                                    marginRight: 5
                                                }}>{evDay}</span>
                                                <span
                                                    style={{fontSize: 13, color: T.muted}}>{o.offered_at || "—"}</span>
                                            </td>
                                            <td style={{padding: "10px 14px", borderTop: `1px solid ${T.border}`}}><Pill
                                                color="red">Done</Pill></td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>

                    <div style={{
                        position: "absolute",
                        inset: 0,
                        overflowY: "auto",
                        overflowX: "auto",
                        display: tab === 3 ? "flex" : "none",
                        flexDirection: "column"
                    }}>

                        {/* Summary strip — commission / tip / surge / total chips */}
                        <div style={{
                            flexShrink: 0,
                            display: "flex",
                            gap: 8,
                            padding: "12px 20px",
                            borderBottom: `1px solid ${T.border}`,
                            background: T.subtle,
                            flexWrap: "wrap",
                            alignItems: "center"
                        }}>
                            {[
                                {label: "Total", val: earnings.total, fg: T.green, bg: T.greenB},
                                {label: "Commission", val: earnings.commission, fg: T.blue, bg: T.blueB},
                                {label: "Tip", val: earnings.tip, fg: T.purple, bg: T.purpleB},
                                {label: "Surge", val: earnings.surge, fg: "#d97706", bg: "#fffbeb"},
                            ].map(({label, val, fg, bg}) => (
                                <div key={label} style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 6,
                                    background: bg,
                                    borderRadius: 8,
                                    padding: "5px 11px",
                                    border: `1px solid ${fg}33`
                                }}>
                                    <span style={{fontSize: 15, fontWeight: 800, color: fg}}>₹{val}</span>
                                    <span
                                        style={{fontSize: 11, fontWeight: 600, color: fg, opacity: 0.8}}>{label}</span>
                                </div>
                            ))}
                        </div>

                        {earnings.orders.length === 0 ? (
                            <div style={{padding: "48px 20px", textAlign: "center", color: T.muted, fontSize: 13}}>No
                                earnings recorded for this day.</div>
                        ) : (
                            <div style={{flex: 1, minHeight: 0, overflowX: "auto"}}>
                                <table style={{width: "100%", borderCollapse: "collapse", minWidth: 520}}>
                                    <thead>
                                    <tr>
                                        {["#", "Order ID", "Commission", "Tip", "Surge", "Total"].map(h => (
                                            <th key={h} style={{
                                                padding: "9px 14px",
                                                fontSize: 10,
                                                fontWeight: 700,
                                                textTransform: "uppercase",
                                                letterSpacing: "0.05em",
                                                color: T.muted,
                                                textAlign: "left",
                                                whiteSpace: "nowrap",
                                                position: "sticky",
                                                top: 0,
                                                background: T.subtle,
                                                borderBottom: `1px solid ${T.border}`,
                                                zIndex: 1
                                            }}>{h}</th>
                                        ))}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {earnings.orders.map((o, idx) => (
                                        <tr key={idx}
                                            onMouseEnter={e => e.currentTarget.style.background = T.subtle}
                                            onMouseLeave={e => e.currentTarget.style.background = ""}>
                                            <td style={{
                                                padding: "10px 14px",
                                                fontSize: 12,
                                                color: T.muted,
                                                borderTop: `1px solid ${T.border}`
                                            }}>{idx + 1}</td>
                                            <td style={{padding: "10px 14px", borderTop: `1px solid ${T.border}`}}>
                                                <a href={`/order/${o.order_id}`} target="_blank"
                                                   rel="noopener noreferrer"
                                                   onClick={e => {
                                                       e.preventDefault();
                                                       onOrderClick(o.order_id);
                                                   }}
                                                   style={{
                                                       display: "inline-flex",
                                                       alignItems: "center",
                                                       gap: 5,
                                                       fontSize: 12,
                                                       fontWeight: 700,
                                                       color: T.blue,
                                                       textDecoration: "none",
                                                       border: `1px solid ${T.blue}33`,
                                                       borderRadius: 6,
                                                       padding: "3px 9px",
                                                       cursor: "pointer"
                                                   }}>
                                                    {o.order_id}
                                                </a>
                                            </td>
                                            {/* Commission */}
                                            <td style={{padding: "10px 14px", borderTop: `1px solid ${T.border}`}}>
                                                {o.commission > 0
                                                    ? <span style={{
                                                        fontSize: 13,
                                                        fontWeight: 700,
                                                        color: T.blue
                                                    }}>₹{o.commission}</span>
                                                    : <span style={{color: T.muted, fontSize: 12}}>—</span>}
                                            </td>
                                            {/* Tip */}
                                            <td style={{padding: "10px 14px", borderTop: `1px solid ${T.border}`}}>
                                                {o.tip > 0
                                                    ? <span style={{
                                                        fontSize: 13,
                                                        fontWeight: 700,
                                                        color: T.purple
                                                    }}>₹{o.tip}</span>
                                                    : <span style={{color: T.muted, fontSize: 12}}>—</span>}
                                            </td>
                                            {/* Surge */}
                                            <td style={{padding: "10px 14px", borderTop: `1px solid ${T.border}`}}>
                                                {o.surge > 0
                                                    ? <span style={{
                                                        fontSize: 13,
                                                        fontWeight: 700,
                                                        color: "#d97706"
                                                    }}>₹{o.surge}</span>
                                                    : <span style={{color: T.muted, fontSize: 12}}>—</span>}
                                            </td>
                                            {/* Total */}
                                            <td style={{padding: "10px 14px", borderTop: `1px solid ${T.border}`}}>
                                                <span style={{
                                                    fontSize: 13,
                                                    fontWeight: 800,
                                                    color: T.green
                                                }}>₹{o.total}</span>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                    {/* Footer totals row */}
                                    <tfoot>
                                    <tr style={{background: T.subtle, borderTop: `2px solid ${T.border}`}}>
                                        <td colSpan={2} style={{
                                            padding: "10px 14px",
                                            fontSize: 11,
                                            fontWeight: 700,
                                            color: T.muted,
                                            textTransform: "uppercase",
                                            letterSpacing: "0.05em"
                                        }}>
                                            Total
                                            · {earnings.orders.length} order{earnings.orders.length !== 1 ? "s" : ""}
                                        </td>
                                        <td style={{padding: "10px 14px"}}>
                                            <span style={{
                                                fontSize: 13,
                                                fontWeight: 800,
                                                color: T.blue
                                            }}>₹{earnings.commission}</span>
                                        </td>
                                        <td style={{padding: "10px 14px"}}>
                                            <span style={{
                                                fontSize: 13,
                                                fontWeight: 800,
                                                color: T.purple
                                            }}>₹{earnings.tip}</span>
                                        </td>
                                        <td style={{padding: "10px 14px"}}>
                                            <span style={{
                                                fontSize: 13,
                                                fontWeight: 800,
                                                color: "#d97706"
                                            }}>₹{earnings.surge}</span>
                                        </td>
                                        <td style={{padding: "10px 14px"}}>
                                            <span style={{
                                                fontSize: 14,
                                                fontWeight: 800,
                                                color: T.green
                                            }}>₹{earnings.total}</span>
                                        </td>
                                    </tr>
                                    </tfoot>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

// ─── Shift dropdown ───────────────────────────────────────────────────────────
function ShiftDropdown({shifts, selected, onChange}) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        const close = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", close);
        return () => document.removeEventListener("mousedown", close);
    }, []);
    return (
        <div ref={ref} style={{position: "relative"}}>
            <button onClick={() => setOpen(o => !o)} style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                background: T.white,
                border: `1px solid ${T.border}`,
                borderRadius: 8,
                padding: "7px 12px",
                fontSize: 13,
                fontWeight: 600,
                color: T.text,
                cursor: "pointer",
                minWidth: 220,
                height: 34
            }}>
                <span style={{color: T.muted, display: "flex"}}><Icon.Clock/></span>
                <span style={{
                    flex: 1,
                    textAlign: "left"
                }}>{selected ? `${selected.shift_name} · ${fmt12(selected.start_time)} – ${fmt12(selected.end_time)}` : "Select Shift"}</span>
                <span style={{color: T.muted, display: "flex"}}><Icon.ChevDown/></span>
            </button>
            {open && (
                <div style={{
                    position: "absolute",
                    top: "calc(100% + 4px)",
                    left: 0,
                    minWidth: "100%",
                    background: T.white,
                    border: `1px solid ${T.border}`,
                    borderRadius: 8,
                    zIndex: 200,
                    boxShadow: "0 8px 28px rgba(0,0,0,.12)",
                    overflow: "hidden"
                }}>
                    {shifts.map(s => (
                        <div key={s.id} onClick={() => {
                            onChange(s);
                            setOpen(false);
                        }}
                             style={{
                                 padding: "10px 14px",
                                 cursor: "pointer",
                                 background: selected?.id === s.id ? T.blueB : "transparent",
                                 color: selected?.id === s.id ? T.blue : T.text
                             }}
                             onMouseEnter={e => {
                                 if (selected?.id !== s.id) e.currentTarget.style.background = T.subtle;
                             }}
                             onMouseLeave={e => {
                                 if (selected?.id !== s.id) e.currentTarget.style.background = "transparent";
                             }}>
                            <div style={{fontSize: 13, fontWeight: 600}}>{s.shift_name}</div>
                            <div style={{
                                fontSize: 11,
                                color: T.muted,
                                marginTop: 1
                            }}>{fmt12(s.start_time)} – {fmt12(s.end_time)}</div>
                        </div>
                    ))}
                    {shifts.length === 0 &&
                        <div style={{padding: 14, color: T.muted, fontSize: 13, textAlign: "center"}}>No shifts
                            found</div>}
                </div>
            )}
        </div>
    );
}


const isValid = (lat, lng) =>
    lat != null && lng != null && !isNaN(Number(lat)) && !isNaN(Number(lng));



function RiderProfileModal({ guy, isOnline, onClose }) {
    const [locationData, setLocationData] = useState(null);
    const [locationLoading, setLocationLoading] = useState(false);

    const user   = guy.user ?? {};
    const detail = user.delivery_guy_detail ?? {};
    const photo  = detail.photo
        ? `https://food.totalfresh.co/assets/img/delivery/${detail.photo}`
        : null;

    const joinedAt = user.created_at
        ? new Date(user.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })
        : "—";

    // Fetch live location for this guy
    const fetchLocation = useCallback(async () => {
        setLocationLoading(true);
        try {
            const live = await apiFetchDeliveryGuyLocation(user.id);
            if (live && isValid(live.lat, live.lng)) {
                setLocationData({ lat: live.lat, lng: live.lng, heading: live.heading ?? detail.heading ?? -1 });
                setLocationLoading(false);
                return;
            }
        } catch { /* fall through */ }
        // Fallback to detail coords
        const fbLat = detail.delivery_lat;
        const fbLng = detail.delivery_long;
        if (fbLat && fbLng && !isNaN(parseFloat(fbLat)) && !isNaN(parseFloat(fbLng))) {
            setLocationData({ lat: fbLat, lng: fbLng, heading: detail.heading ?? -1 });
        } else {
            setLocationData(null);
        }
        setLocationLoading(false);
    }, [user.id, detail]);

    // Fetch on mount
    useEffect(() => { fetchLocation(); }, [fetchLocation]);

    useEffect(() => {
        const handler = (e) => { if (e.key === "Escape") onClose(); };
        document.addEventListener("keydown", handler);
        document.body.style.overflow = "hidden";
        return () => { document.removeEventListener("keydown", handler); document.body.style.overflow = ""; };
    }, [onClose]);

    const lat = locationData?.lat;
    const lng = locationData?.lng;
    const hasLocation = lat && lng;

    const fields = [
        { label: "Email",   value: user.email              ?? "—", icon: <Mail size={13} />     },
        { label: "Phone",   value: user.phone              ?? "—", icon: <Phone size={13} />    },
        { label: "Vehicle", value: detail.vehicle_number   ?? "—", icon: <Bike size={13} />     },
        { label: "Joined",  value: joinedAt,                        icon: <Calendar size={13} /> },
    ];

    return (
        <div
            onClick={onClose}
            style={{ position: "fixed", inset: 0, background: "rgba(15,20,30,.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, marginTop: 60, backdropFilter: "blur(3px)" }}
        >
            <div
                onClick={e => e.stopPropagation()}
                style={{ background: T.white, borderRadius: 16, width: "100%", maxWidth: 600, display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 24px 60px rgba(0,0,0,.2)", maxHeight: "85vh" }}
            >
                {/* ── Header bar ── */}
                <div style={{ flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 18px", borderBottom: `1px solid ${T.border}` }}>
                    <span style={{ fontSize: 13, fontWeight: 800, color: T.text }}>Rider Profile</span>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <button
                            onClick={fetchLocation}
                            title="Refresh location"
                            style={{ width: 30, height: 30, borderRadius: 7, border: `1px solid ${T.border}`, background: "none", cursor: "pointer", color: T.muted, display: "flex", alignItems: "center", justifyContent: "center", transition: "background .15s" }}
                            onMouseEnter={e => e.currentTarget.style.background = T.subtle}
                            onMouseLeave={e => e.currentTarget.style.background = "none"}
                        >
                            <RefreshCw size={13} style={{ animation: locationLoading ? "spin .7s linear infinite" : "none" }} />
                        </button>
                        <button
                            onClick={onClose}
                            style={{ width: 30, height: 30, borderRadius: 7, border: `1px solid ${T.border}`, background: "none", cursor: "pointer", fontSize: 16, color: T.muted, display: "flex", alignItems: "center", justifyContent: "center" }}
                        >✕</button>
                    </div>
                </div>

                {/* ── Scrollable body ── */}
                <div style={{ overflowY: "auto", flex: 1 }}>

                    {/* ── Avatar LEFT · name + status RIGHT ── */}
                    <div style={{ display: "flex", alignItems: "center", gap: 16, padding: "20px 20px 16px", borderBottom: `1px solid ${T.border}` }}>

                        {/* Avatar */}
                        {photo ? (
                            <img
                                src={photo}
                                alt={guy.delivery_guy_name}
                                style={{ width: 60, height: 60, borderRadius: "50%", objectFit: "cover", border: `3px solid ${T.border}`, flexShrink: 0 }}
                                onError={e => { e.currentTarget.style.display = "none"; }}
                            />
                        ) : (
                            <div style={{ flexShrink: 0 }}>
                                <Avatar name={guy.delivery_guy_name} size={50} />
                            </div>
                        )}

                        {/* Name + description + online badge */}
                        <div style={{ minWidth: 0 }}>
                            <div style={{ fontSize: 16, fontWeight: 800, color: T.text, lineHeight: 1.2 }}>{guy.delivery_guy_name}</div>
                            {detail.description && (
                                <div style={{ fontSize: 11, color: T.muted, marginTop: 3 }}>{detail.description}</div>
                            )}
                            <div style={{ marginTop: 8 }}>
                                {isOnline ? (
                                    <span style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 11, fontWeight: 800, background: T.greenB, color: T.green, border: `1px solid ${T.green}33`, borderRadius: 20, padding: "3px 10px" }}>
                                        <OnlineDot size={6} /> ONLINE
                                    </span>
                                ) : (
                                    <span style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 11, fontWeight: 700, background: T.subtle, color: T.muted, border: `1px solid ${T.border}`, borderRadius: 20, padding: "3px 10px" }}>
                                        <div style={{ width: 6, height: 6, borderRadius: "50%", background: T.muted, flexShrink: 0 }} />
                                        OFFLINE
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* ── Info fields ── */}
                    <div style={{ padding: "14px 18px", borderBottom: `1px solid ${T.border}`, display: "flex", flexDirection: "column", gap: 10 }}>
                        {fields.map(({ label, value, icon }) => (
                            <div key={label} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                <span style={{ color: T.muted, display: "flex", flexShrink: 0 }}>{icon}</span>
                                <span style={{ fontSize: 11, fontWeight: 700, color: T.muted, width: 62, flexShrink: 0, textTransform: "uppercase", letterSpacing: "0.04em" }}>{label}</span>
                                <span style={{ fontSize: 13, fontWeight: 600, color: T.text }}>{value}</span>
                            </div>
                        ))}
                    </div>

                    {/* ── Live location map ── */}
                    <div style={{ padding: "14px 18px 18px" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 10 }}>
                            <MapPin size={13} color={T.blue} />
                            <span style={{ fontSize: 11, fontWeight: 700, color: T.muted, textTransform: "uppercase", letterSpacing: "0.06em" }}>Live Location</span>
                            {/*{hasLocation && (*/}
                            {/*    <span style={{ marginLeft: "auto", fontSize: 10, color: T.muted }}>*/}
                            {/*        {parseFloat(lat).toFixed(5)}, {parseFloat(lng).toFixed(5)}*/}
                            {/*    </span>*/}
                            {/*)}*/}
                        </div>

                        {locationLoading ? (
                            <div style={{ height: 220, borderRadius: 12, background: T.subtle, border: `1px solid ${T.border}`, display: "flex", alignItems: "center", justifyContent: "center", gap: 8, color: T.muted, fontSize: 12, fontWeight: 600 }}>
                                <Icon.Spin /> Fetching location…
                            </div>
                        ) : hasLocation ? (
                            // key on lat+lng so map re-centers whenever location changes after refresh
                            <div key={`${lat}-${lng}`} style={{ height: 250, borderRadius: 12, overflow: "hidden", border: `1px solid ${T.border}` }}>
                                <MapContainer
                                    center={[parseFloat(lat), parseFloat(lng)]}
                                    zoom={15}
                                    style={{ height: "100%", width: "100%" }}
                                    attributionControl={false}
                                >
                                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                    <Marker
                                        position={[parseFloat(lat), parseFloat(lng)]}
                                        icon={makeIcon(locationData.heading, T.blue)}
                                    >
                                        <Popup>{detail.name ?? guy.delivery_guy_name}</Popup>
                                    </Marker>
                                </MapContainer>
                            </div>
                        ) : (
                            <div style={{ height: 100, borderRadius: 12, background: T.subtle, border: `1px dashed ${T.border}`, display: "flex", alignItems: "center", justifyContent: "center", color: T.muted, fontSize: 12, fontWeight: 600, gap: 8 }}>
                                <MapPin size={15} color={T.border} /> Location not available
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
}


// ─── Table columns ────────────────────────────────────────────────────────────
const COLS = [
    {
        key: "first_login_at", label: "First Login", IC: Icon.Login, color: T.green,
        render: (v) => v ? <span style={{fontSize: 13, fontWeight: 700, color: T.green}}>{v}</span> :
            <span style={{color: T.muted}}>—</span>
    },
    {
        key: "last_logout_at", label: "Last Logout", IC: Icon.Logout, color: T.red,
        render: (v) => v ? <span style={{fontSize: 13, fontWeight: 700, color: T.red}}>{v}</span> :
            <span style={{color: T.muted}}>—</span>
    },
    {
        key: "active_seconds", label: "Active", IC: Icon.Zap, color: T.green,
        render: (v) => v > 0 ? <Pill color="green">{fmtSec(v)}</Pill> : <span style={{color: T.muted}}>—</span>
    },
    {
        key: "inactive_seconds", label: "Inactive", IC: Icon.Moon, color: T.red,
        render: (v) => v > 0 ? <Pill color="red">{fmtSec(v)}</Pill> : <span style={{color: T.muted}}>—</span>
    },
    {
        key: "offered_count", label: "Offered", IC: Icon.Mail, color: T.amber,
        render: (v) => v > 0 ? <Pill color="amber">{v} orders</Pill> : <span style={{color: T.muted}}>0</span>
    },
    {
        key: "accepted_count", label: "Accepted", IC: Icon.Check, color: T.blue,
        render: (v) => v > 0 ? <Pill color="blue">{v} orders</Pill> : <span style={{color: T.muted}}>0</span>
    },
    {
        key: "done_count", label: "Done", IC: Icon.Check, color: T.green,
        render: (v) => v > 0 ? <Pill color="green">{v} done</Pill> : <span style={{color: T.muted}}>0</span>
    },
    {
        key: "action_orders_count", label: "Action", IC: Icon.Bar, color: T.red,
        render: (v) => v > 0 ? <Pill color="red">{v} orders</Pill> : <span style={{color: T.muted}}>0</span>
    },
    {
        key: "_rate", label: "Accept Rate", IC: Icon.Bar, color: T.purple,
        render: (_, d) => {
            if (!d?.offered_count) return <span style={{color: T.muted}}>—</span>;
            const pct = Math.round(d.accepted_count / d.offered_count * 100);
            return <Pill color={pct >= 70 ? "green" : pct >= 40 ? "amber" : "red"}>{pct}%</Pill>;
        }
    },
];

// ─── Main ─────────────────────────────────────────────────────────────────────
export default function ShiftReport() {
    const {shiftId} = useParams();

    const [shifts, setShifts] = useState([]);
    const [selectedShift, setSelectedShift] = useState(null);
    const [guys, setGuys] = useState([]);
    const [guysLoading, setGuysLoading] = useState(false);
    const [selectedGuy, setSelectedGuy] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [search, setSearch] = useState("");
    const [from, setFrom] = useState(sevenAgo());
    const [to, setTo] = useState(todayStr());
    const [report, setReport] = useState(null);
    const [reportLoading, setReportLoading] = useState(false);
    const [initLoading, setInitLoading] = useState(true);
    const [detailDay, setDetailDay] = useState(null);
    const [profileOpen, setProfileOpen] = useState(false);


    const [_, setActionOrderPrice] = useState(null);

    // ── Load shifts once on mount ──────────────────────────────────────────
    useEffect(() => {
        getAllShifts().then(res => {
            if (res.success) {
                setShifts(res.data?.shifts);
                setActionOrderPrice(res?.data?.actionOrderPrice);
                const found = res.data?.shifts.find(s => String(s.id) === String(shiftId));
                if (found) {
                    setSelectedShift(found);
                    const {from: f, to: t} = getShiftPeriod(found);
                    setFrom(f);
                    setTo(t);
                }
            }
        }).finally(() => setInitLoading(false));
    }, [shiftId]);

    // ── Load riders when shift changes ────────────────────────────────────
    useEffect(() => {
        if (!selectedShift) {
            setGuys([]);
            setSelectedGuy(null);
            setReport(null);
            return;
        }
        setGuysLoading(true);
        setGuys([]);
        setSelectedGuy(null);
        setReport(null);
        getDeliveryGuysByShift(selectedShift.id)
            .then(res => {
                if (res.success) setGuys(res.data);
            })
            .finally(() => setGuysLoading(false));
    }, [selectedShift]);

    // ── Fetch report (accepts explicit dates to avoid stale state) ─────────
    const fetchReport = async (guy, shiftOverride, fromOverride, toOverride) => {
        const shift = shiftOverride ?? selectedShift;
        const fromVal = fromOverride ?? from;
        const toVal = toOverride ?? to;
        if (!shift || !guy) return;
        setReportLoading(true);
        setReport(null);
        try {
            const res = await getShiftReport(shift.id, {
                from: toApiDate(fromVal),
                to: toApiDate(toVal),
                delivery_guy_id: guy.id,
            });
            if (res.success) setReport(res.data);
        } catch (e) {
            console.error("Shift report error", e);
        } finally {
            setReportLoading(false);
        }
    };

    // ── Select a rider — compute fresh dates and pass directly ─────────────
    const selectGuy = (guy) => {
        setSelectedGuy(guy);
        const {from: f, to: t} = getShiftPeriod(selectedShift);
        setFrom(f);
        setTo(t);
        fetchReport(guy, null, f, t);
    };

    // ── Change shift from dropdown ─────────────────────────────────────────
    const handleShiftChange = (s) => {
        const { from: f, to: t } = getShiftPeriod(s);
        setSelectedShift(s);
        setFrom(f);
        setTo(t);
        setSelectedGuy(null);
        setReport(null);
    };

    // ── Manual search with current (possibly edited) dates ─────────────────
    const handleSearch = () => { if (selectedGuy) fetchReport(selectedGuy); };

    const reportDays    = report?.days ?? {};
    const reportGuy     = report?.guy  ?? null;
    const sortedDayKeys = Object.keys(reportDays).sort();
    const filteredGuys  = search ? guys.filter(g => g.name.toLowerCase().includes(search.toLowerCase())) : guys;

    const totalShiftSeconds = sortedDayKeys.reduce((sum, dayKey) => {
        return sum + (reportDays[dayKey]?.shift_duration_seconds || 0);
    }, 0);

    const completedShiftSeconds = sortedDayKeys?.reduce((sum, dayKey) => {
        return sum + (reportDays[dayKey]?.completed_shift_duration_seconds || 0);
    }, 0);

    const totalActiveSeconds = reportGuy?.total?.active_seconds || 0;
    const totalInActiveSeconds = reportGuy?.total?.inactive_seconds || 0;


    const shiftPercent = totalShiftSeconds > 0
        ? Math.round((totalActiveSeconds / totalShiftSeconds) * 100)
        : 0;

    // [NEW] Derive live online status for selected guy from the guys list
    const selectedGuyLive = guys.find(g => g.id === selectedGuy?.id);
    const isSelectedOnline = selectedGuyLive?.status === 1;

    if (initLoading) return (
        <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif", background: T.bg, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", color: T.muted }}>
            <Icon.Spin /><span style={{ marginLeft: 10, fontSize: 14 }}>Loading shifts…</span>
        </div>
    );

    return (
        <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif", background: T.bg, color: T.text, display: "flex", flexDirection: "column", height: "100vh", overflow: "hidden" }}>
            <style>{`
                @keyframes spin { to { transform: rotate(360deg); } }
                @keyframes onlinePulse {
                    0%, 100% { transform: scale(1); opacity: 0.25; }
                    50%       { transform: scale(2.6); opacity: 0; }
                }
                *, *::before, *::after { box-sizing: border-box; }
                ::-webkit-scrollbar { width: 5px; height: 5px; }
                ::-webkit-scrollbar-track { background: transparent; }
                ::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 10px; }
            `}</style>

            {/* ══ TOP BAR — old, unchanged except Earnings button added ══ */}
            <div style={{ flexShrink: 0, background: T.white, borderBottom: `1px solid ${T.border}`, padding: "11px 18px", display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", zIndex: 50 }}>
                <button onClick={() => setSidebarOpen(o => !o)} title={sidebarOpen ? "Hide riders" : "Show riders"}
                        style={{ background: sidebarOpen ? T.blueB : T.subtle, color: sidebarOpen ? T.blue : T.muted, border: `1px solid ${sidebarOpen ? T.blue + "55" : T.border}`, borderRadius: 7, width: 34, height: 34, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", flexShrink: 0, transition: "all .15s" }}>
                    <Icon.Menu />
                </button>
                <div style={{ width: 1, height: 22, background: T.border, flexShrink: 0 }} />

                <ShiftDropdown shifts={shifts} selected={selectedShift} onChange={handleShiftChange} />

                {/*{!sidebarOpen && selectedGuy && (*/}
                {/*    <div style={{ display: "flex", alignItems: "center", gap: 7, background: T.subtle, border: `1px solid ${T.border}`, borderRadius: 7, padding: "4px 10px 4px 6px" }}>*/}
                {/*        <Avatar name={selectedGuy.name} size={22} />*/}
                {/*        <span style={{ fontSize: 12, fontWeight: 600, color: T.text }}>{selectedGuy.name}</span>*/}
                {/*    </div>*/}
                {/*)}*/}

                <div style={{ flex: 1 }} />

                {/* [NEW] Earnings & Incentives — lucide icon, no functionality */}
                <button
                    onClick={() => window.open(`/shifts/${shiftId}/earnings`, "_blank")}
                    title="Incentive"
                    style={{
                        display: "flex", alignItems: "center", gap: 6,
                        background: T.subtle, color: T.text,
                        border: `1px solid ${T.border}`, borderRadius: 8,
                        padding: "6px 13px", fontSize: 12, fontWeight: 600,
                        height: 34, cursor: "pointer",
                        whiteSpace: "nowrap", flexShrink: 0,
                    }}
                >
                    <TrendingUp size={13} />
                    Earnings &amp; Incentives
                </button>

                {selectedGuy && (
                    <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                        {[["From", from, setFrom], ["To", to, setTo]].map(([lbl, val, set]) => (
                            <div key={lbl} style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                <label style={{ fontSize: 11, fontWeight: 700, color: T.muted, textTransform: "uppercase", letterSpacing: "0.04em", whiteSpace: "nowrap" }}>{lbl}</label>
                                <input type="date" value={val} onChange={e => set(e.target.value)} style={{ border: `1px solid ${T.border}`, borderRadius: 7, padding: "6px 9px", fontSize: 13, outline: "none", color: T.text, background: T.white, height: 34 }} />
                            </div>
                        ))}
                        <button onClick={handleSearch} disabled={reportLoading}
                                style={{ background: T.blue, color: "#fff", border: "none", borderRadius: 7, padding: "0 16px", fontSize: 13, fontWeight: 700, height: 34, cursor: reportLoading ? "not-allowed" : "pointer", opacity: reportLoading ? 0.6 : 1, display: "flex", alignItems: "center", gap: 6 }}>
                            <Icon.Search />{reportLoading ? "Loading…" : "Search"}
                        </button>
                    </div>
                )}
            </div>

            {/* ══ BODY ══ */}
            <div style={{ flex: 1, display: "flex", overflow: "hidden" }}>

                {/* ── SIDEBAR ── */}
                <div style={{ flexShrink: 0, width: sidebarOpen ? T.sideW : 0, overflow: "hidden", transition: "width .22s ease", borderRight: `1px solid ${T.border}`, background: T.white, display: "flex", flexDirection: "column" }}>
                    <div style={{ width: T.sideW, display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}>
                        <div style={{ flexShrink: 0, padding: "13px 13px 10px", borderBottom: `1px solid ${T.border}` }}>
                            <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 10 }}>
                                <span style={{ color: T.muted, display: "flex" }}><Icon.Riders /></span>
                                <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", color: T.muted }}>Delivery Riders</span>
                                {guys.length > 0 && <span style={{ marginLeft: "auto", background: T.blueB, color: T.blue, borderRadius: 10, padding: "1px 8px", fontSize: 10, fontWeight: 800 }}>{guys.length}</span>}
                            </div>
                            <div style={{ position: "relative" }}>
                                <span style={{ position: "absolute", left: 9, top: "50%", transform: "translateY(-50%)", color: T.muted, pointerEvents: "none", display: "flex" }}><Icon.Search /></span>
                                <input placeholder="Search riders…" value={search} onChange={e => setSearch(e.target.value)} style={{ width: "100%", border: `1px solid ${T.border}`, borderRadius: 7, padding: "7px 10px 7px 30px", fontSize: 12, outline: "none", color: T.text, background: T.subtle }} />
                            </div>
                        </div>
                        <div style={{ flex: 1, overflowY: "auto" }}>
                            {!selectedShift && <div style={{ padding: "28px 14px", textAlign: "center", color: T.muted, fontSize: 12 }}>Select a shift to see riders</div>}
                            {selectedShift && guysLoading && <div style={{ padding: "28px 14px", display: "flex", flexDirection: "column", alignItems: "center", gap: 8, color: T.muted, fontSize: 12 }}><Icon.Spin /><span>Loading riders…</span></div>}
                            {selectedShift && !guysLoading && filteredGuys.length === 0 && <div style={{ padding: "28px 14px", textAlign: "center", color: T.muted, fontSize: 12 }}>{search ? "No riders match" : "No riders in this shift"}</div>}
                            {filteredGuys.map(guy => {
                                const active   = selectedGuy?.id === guy.id;
                                const isOnline = guy.status === 1;  // [NEW] online check
                                return (
                                    <div key={guy.id} onClick={() => selectGuy(guy)}
                                         style={{ display: "flex", alignItems: "center", gap: 10, padding: "9px 13px", cursor: "pointer", borderLeft: `3px solid ${active ? T.blue : "transparent"}`, background: active ? T.blueB : "transparent", transition: "background .1s, border-color .1s" }}
                                         onMouseEnter={e => { if (!active) e.currentTarget.style.background = T.subtle; }}
                                         onMouseLeave={e => { if (!active) e.currentTarget.style.background = "transparent"; }}>
                                        {/* [NEW] Avatar wrapper with online dot on corner */}
                                        <div style={{ position: "relative", flexShrink: 0 }}>
                                            <Avatar name={guy.name} size={34} />
                                            {isOnline && (
                                                <div style={{
                                                    position: "absolute", bottom: 0, right: 0,
                                                    width: 9, height: 9, borderRadius: "50%",
                                                    background: T.green, border: `2px solid ${T.white}`,
                                                    animation: "onlinePulse 1.8s ease-in-out infinite",
                                                }} />
                                            )}
                                        </div>
                                        <div style={{ minWidth: 0, flex: 1 }}>
                                            {/* [NEW] name row with inline ONLINE badge */}
                                            <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
                                                <span style={{ fontSize: 13, fontWeight: active ? 700 : 500, color: active ? T.blue : T.text, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{guy.name}</span>
                                                {isOnline && (
                                                    <span style={{ fontSize: 9, fontWeight: 800, background: T.greenB, color: T.green, border: `1px solid ${T.green}33`, borderRadius: 4, padding: "1px 5px", letterSpacing: "0.03em", flexShrink: 0 }}>ONLINE</span>
                                                )}
                                            </div>
                                            {guy.phone && <div style={{ fontSize: 11, color: T.muted, marginTop: 1 }}>{guy.phone}</div>}
                                        </div>
                                        {active && <span style={{ color: T.blue, flexShrink: 0, display: "flex" }}><Icon.ChevRight /></span>}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>

                {/* ── MAIN PANEL ── */}
                <div style={{ flex: 1, overflowY: "auto", padding: "22px 22px 60px" }}>
                    {!selectedShift && <EmptyState icon={<Icon.Empty />} title="No shift selected" sub="Pick a shift from the top bar to get started" />}
                    {selectedShift && !selectedGuy && !guysLoading && <EmptyState icon={<Icon.Riders />} title={`${guys.length} rider${guys.length !== 1 ? "s" : ""} in ${selectedShift.shift_name}`} sub="Click any rider on the left to view their shift report" />}
                    {reportLoading && <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 10, paddingTop: 80, color: T.muted }}><Icon.Spin /><span style={{ fontSize: 13 }}>Calculating shift report…</span></div>}

                    {report && reportGuy && !reportLoading && (
                        <>
                            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 18 }}>

                                {/* Avatar — photo if available, else initials */}
                                {(() => {
                                    const photo = reportGuy.user?.delivery_guy_detail?.photo;

                                    console.log("photo: ", photo);
                                    const photoUrl = photo
                                        ? `https://food.totalfresh.co/assets/img/delivery/${photo}`
                                        : null;
                                    return photoUrl ? (
                                        <img
                                            src={photoUrl}
                                            alt={reportGuy.delivery_guy_name}
                                            style={{ width: 44, height: 44, borderRadius: "50%", objectFit: "cover", flexShrink: 0, border: `2px solid ${T.border}` }}
                                            onError={e => { e.currentTarget.style.display = "none"; }}
                                        />
                                    ) : (
                                        <Avatar name={reportGuy.delivery_guy_name} size={44} />
                                    );
                                })()}

                                <div style={{ flex: 1 }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: 8, lineHeight: 1.1 }}>
                                        <span style={{ fontSize: 17, fontWeight: 800, color: T.text }}>{reportGuy.delivery_guy_name}</span>
                                        {isSelectedOnline ? (
                                            <span style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 10, fontWeight: 800, background: T.greenB, color: T.green, border: `1px solid ${T.green}33`, borderRadius: 5, padding: "2px 7px", letterSpacing: "0.03em" }}>
                    <OnlineDot size={6} /> ONLINE
                </span>
                                        ) : (
                                            <span style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: 10, fontWeight: 700, background: T.subtle, color: T.muted, border: `1px solid ${T.border}`, borderRadius: 5, padding: "2px 7px", letterSpacing: "0.03em" }}>
                    <div style={{ width: 6, height: 6, borderRadius: "50%", background: T.muted, flexShrink: 0 }} />
                    OFFLINE
                </span>
                                        )}
                                    </div>
                                    <div style={{ fontSize: 12, color: T.muted, marginTop: 4 }}>
                                        {selectedShift?.shift_name} · {fmt12(selectedShift?.start_time)} – {fmt12(selectedShift?.end_time)}
                                        &nbsp;·&nbsp;{toApiDate(from)} → {toApiDate(to)}
                                    </div>
                                </div>

                                {/* View Profile button */}
                                <button
                                    onClick={() => setProfileOpen(true)}
                                    style={{ display: "flex", alignItems: "center", gap: 6, background: T.subtle, color: T.text, border: `1px solid ${T.border}`, borderRadius: 8, padding: "6px 13px", fontSize: 12, fontWeight: 600, height: 34, cursor: "pointer", whiteSpace: "nowrap", flexShrink: 0 }}
                                    onMouseEnter={e => e.currentTarget.style.background = T.blueB}
                                    onMouseLeave={e => e.currentTarget.style.background = T.subtle}
                                >
                                    <User size={13} /> View Profile
                                </button>
                            </div>

                            {/* ── Profile popup ── */}
                            {profileOpen && (
                                <RiderProfileModal
                                    guy={reportGuy}
                                    isOnline={isSelectedOnline}
                                    onClose={() => setProfileOpen(false)}
                                />
                            )}

                            {/* ── Stat cards — [CHANGED] grid so they wrap into rows naturally ── */}
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(170px, 1fr))", gap: 10, marginBottom: 18 }}>
                                <StatCard
                                    icon={Icon.Clock}
                                    label="Total Shift"
                                    color="blue"
                                    value={fmtSec(totalShiftSeconds)}
                                />

                                <StatCard
                                    icon={Icon.Zap}
                                    label="Active %"
                                    color={
                                        shiftPercent >= 70
                                            ? "green"
                                            : shiftPercent >= 40
                                                ? "amber"
                                                : "red"
                                    }
                                    value={`${shiftPercent}%`}
                                    sub={`${fmtSec((completedShiftSeconds))} completed shift`}
                                />

                                <StatCard icon={Icon.Zap}   label="Total Active"    color="green" value={fmtSec(reportGuy.total.active_seconds)} />
                                <StatCard icon={Icon.Moon}  label="Total Inactive"  color="red"   value={fmtSec(reportGuy.total.inactive_seconds)} />
                                <StatCard icon={Icon.Mail}  label="Orders Offered"  color="amber" value={reportGuy.total.offered_count} />
                                <StatCard icon={Icon.Check} label="Delivered"       color="green" value={reportGuy.total.done_count}
                                          sub={reportGuy.total.accepted_count > 0 ? `${Math.round(reportGuy.total.done_count / reportGuy.total.accepted_count * 100)}% completion` : undefined} />
                                <StatCard icon={Icon.Check} label="Orders Accepted" color="blue"  value={reportGuy.total.accepted_count}
                                          sub={reportGuy.total.offered_count > 0 ? `${Math.round(reportGuy.total.accepted_count / reportGuy.total.offered_count * 100)}% acceptance rate` : undefined} />
                                <StatCard
                                    icon={Icon.Bar}
                                    label="Action Orders"
                                    color="red"
                                    value={reportGuy.total.action_orders_count}
                                    // sub={actionOrderPrice ? `₹${reportGuy.total.action_orders_count * actionOrderPrice} payment` : undefined}
                                />

                                <StatCard
                                    icon={Icon.Check}
                                    label="Total Earnings"
                                    color="green"
                                    value={`₹${(reportGuy.total.total_earnings ?? 0).toFixed(2)}`}
                                    sub={
                                        [
                                            reportGuy.total.total_commission > 0 && `₹${reportGuy.total.total_commission} commission`,
                                            reportGuy.total.total_tip > 0        && `₹${reportGuy.total.total_tip} tip`,
                                            reportGuy.total.total_surge > 0       && `₹${reportGuy.total.total_surge} surge`,
                                        ].filter(Boolean).join(" · ")
                                    }
                                />

                                <StatCard
                                    icon={Icon.Bar}
                                    label="Cash Pending"
                                    color="blue"
                                    value={`₹${reportGuy.total.deliveryCollectionAmount}`}
                                />

                                {(() => {
                                    const rules = (selectedShift?.payout_rules ?? [])
                                        .slice()
                                        .sort((a, b) => Number(a.percent) - Number(b.percent)); // ascending by percent

                                    if (rules.length === 0) return null;

                                    // Find highest bracket where shiftPercent >= rule.percent
                                    let reachedIdx = -1;
                                    for (let i = 0; i < rules.length; i++) {
                                        if (shiftPercent >= Number(rules[i].percent)) reachedIdx = i;
                                    }

                                    const currentRule = reachedIdx >= 0 ? rules[reachedIdx] : null;
                                    const nextRule    = rules[reachedIdx + 1] ?? null;

                                    let value, sub, color;

                                    if (!currentRule) {
                                        // Haven't hit any bracket yet
                                        const first        = rules[0];
                                        const percentNeeded = Number(first.percent) - shiftPercent;
                                        value = "₹0";
                                        sub   = `${percentNeeded}% more active for ₹${first.amount} incentive`;
                                        color = "amber";
                                    } else if (nextRule) {
                                        // On a bracket, next one exists
                                        const percentNeeded = Number(nextRule.percent) - shiftPercent;
                                        value = `₹${currentRule.amount}`;
                                        sub   = `${percentNeeded}% more active for ₹${nextRule.amount}`;
                                        color = "blue";
                                    } else {
                                        // Max bracket reached
                                        value = `₹${currentRule.amount}`;
                                        sub   = "Max incentive reached 🎉";
                                        color = "green";
                                    }

                                    return (
                                        <StatCard
                                            icon={Icon.Zap}
                                            label="Incentive"
                                            color={color}
                                            value={value}
                                            sub={sub}
                                        />
                                    );
                                })()}
                            </div>


                            {/* ── Daily table — completely unchanged ── */}
                            <div style={{ background: T.white, border: `1px solid ${T.border}`, borderRadius: 12, overflow: "hidden" }}>
                                <div style={{ overflowX: "auto" }}>
                                    <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 640 }}>
                                        <thead>
                                        <tr style={{ borderBottom: `2px solid ${T.border}` }}>
                                            <th style={{ padding: "11px 16px", textAlign: "left", fontSize: 11, fontWeight: 700, color: T.muted, background: T.subtle, letterSpacing: "0.05em", textTransform: "uppercase", position: "sticky", left: 0, zIndex: 2, borderRight: `1px solid ${T.border}`, minWidth: 100 }}>Date</th>
                                            {COLS.map(col => (
                                                <th key={col.key} style={{ padding: "11px 13px", minWidth: 108, textAlign: "center", fontSize: 11, fontWeight: 700, color: T.muted, background: T.subtle, letterSpacing: "0.04em", textTransform: "uppercase" }}>
                                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 5 }}><span style={{ color: col.color, display: "flex" }}><col.IC /></span>{col.label}</div>
                                                </th>
                                            ))}
                                            <th style={{ padding: "11px 13px", fontSize: 11, fontWeight: 700, color: T.muted, background: T.subtle, textTransform: "uppercase", letterSpacing: "0.05em" }}></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {sortedDayKeys.map((dateKey, di) => {
                                            const dayObj     = reportDays[dateKey];
                                            const notStarted = dayObj?.shift_status === "not_started";
                                            return (
                                                <tr key={dateKey}
                                                    style={{ borderBottom: di < sortedDayKeys.length - 1 ? `1px solid ${T.border}` : "none" }}
                                                    onMouseEnter={e => e.currentTarget.style.background = T.subtle}
                                                    onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                                                    <td style={{ padding: "11px 16px", background: T.white, position: "sticky", left: 0, zIndex: 1, borderRight: `1px solid ${T.border}` }}>
                                                        <div style={{ fontWeight: 800, color: T.text, fontSize: 13 }}>{toDisplayDate(dateKey)}</div>
                                                        <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>{toDayName(dateKey)}</div>
                                                    </td>
                                                    {notStarted ? (
                                                        // ── Exactly the old pill, unchanged ──
                                                        <td colSpan={COLS.length + 1} style={{ padding: "11px 16px", textAlign: "center" }}>
                                                            <Pill color="amber">🕐 Shift not started yet</Pill>
                                                        </td>
                                                    ) : (
                                                        <>
                                                            {COLS.map(col => (
                                                                <td key={col.key} style={{ padding: "11px 13px", textAlign: "center", fontSize: 13 }}>{col.render(dayObj?.[col.key], dayObj)}</td>
                                                            ))}
                                                            <td style={{ padding: "11px 13px", textAlign: "center" }}>
                                                                <button
                                                                    onClick={() => setDetailDay({ date: dateKey, dayObj })}
                                                                    style={{ background: "none", border: `1px solid ${T.border}`, borderRadius: 6, padding: "4px 10px", fontSize: 11, fontWeight: 700, color: T.blue, cursor: "pointer", whiteSpace: "nowrap" }}
                                                                    onMouseEnter={e => e.currentTarget.style.background = T.blueB}
                                                                    onMouseLeave={e => e.currentTarget.style.background = "none"}>
                                                                    View Details
                                                                </button>
                                                            </td>
                                                        </>
                                                    )}
                                                </tr>
                                            );
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>

            {detailDay && (
                <DayDetailModal
                    day={detailDay.date}
                    dayObj={detailDay.dayObj}
                    shift={selectedShift}
                    guyName={reportGuy?.delivery_guy_name}
                    onClose={() => setDetailDay(null)}
                    onOrderClick={(orderId) => window.open(`/order/${orderId}`, "_blank")}
                />
            )}
        </div>
    );
}